// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.particle-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.element {
  position: absolute;
  font-size: var(--size);
  left: var(--x);
  top: var(--y);
  animation: float-element 15s infinite ease-in-out;
  animation-delay: var(--delay);
  opacity: 0.7;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));
  transform-origin: center center;
  z-index: 3;
}

@keyframes float-element {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg) scale(1);
  }
  25% {
    transform: translate(30px, -20px) rotate(90deg) scale(1.1);
  }
  50% {
    transform: translate(10px, 30px) rotate(180deg) scale(0.9);
  }
  75% {
    transform: translate(-20px, 10px) rotate(270deg) scale(1.05);
  }
}

/* Add responsive styles */
@media (max-width: 768px) {
  .element {
    font-size: calc(var(--size) * 0.8);
  }
}

/* For very small screens */
@media (max-width: 480px) {
  .element {
    font-size: calc(var(--size) * 0.6);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AnimatedBackground/AnimatedBackground.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,iDAAiD;EACjD,6BAA6B;EAC7B,YAAY;EACZ,sDAAsD;EACtD,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,4DAA4D;EAC9D;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,kCAAkC;EACpC;AACF","sourcesContent":[".animated-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.particle-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.floating-elements {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.element {\n  position: absolute;\n  font-size: var(--size);\n  left: var(--x);\n  top: var(--y);\n  animation: float-element 15s infinite ease-in-out;\n  animation-delay: var(--delay);\n  opacity: 0.7;\n  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));\n  transform-origin: center center;\n  z-index: 3;\n}\n\n@keyframes float-element {\n  0%, 100% {\n    transform: translate(0, 0) rotate(0deg) scale(1);\n  }\n  25% {\n    transform: translate(30px, -20px) rotate(90deg) scale(1.1);\n  }\n  50% {\n    transform: translate(10px, 30px) rotate(180deg) scale(0.9);\n  }\n  75% {\n    transform: translate(-20px, 10px) rotate(270deg) scale(1.05);\n  }\n}\n\n/* Add responsive styles */\n@media (max-width: 768px) {\n  .element {\n    font-size: calc(var(--size) * 0.8);\n  }\n}\n\n/* For very small screens */\n@media (max-width: 480px) {\n  .element {\n    font-size: calc(var(--size) * 0.6);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
